import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export type BackNavigationState = {
  from?: string;
};

export function useBackNavigation(fallbackPath: string) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const historyIdx = (window.history.state as { idx?: number } | null)?.idx ?? 0;

    if (historyIdx > 0) {
      navigate(-1);
      return;
    }

    const from = (location.state as BackNavigationState | null)?.from;
    if (from) {
      navigate(from);
      return;
    }

    navigate(fallbackPath);
  }, [navigate, location.state, fallbackPath]);
}

export function buildCurrentPath(pathname: string, search: string): string {
  return `${pathname}${search}`;
}
